/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from "react";
import styled from "styled-components";
import { Field, Form, Formik } from "formik";
import * as yup from "yup";
import Button from "../Buttons/Button";
import Input from "../Input";
import CheckBox from "../Checkbox";
import InlineLink from "../InlineLink";
import { TextSubtitle, TextTitle } from "../../styles";
import signupIllustration from "../../assets/illustrations/signup.svg";
import Card from "../Cards/Card";

interface SignupPageProps {
    termsURL: string;
    handleView: React.Dispatch<React.SetStateAction<string>>;
    mailSignUp: (data: { email: string; password: string; givenName:string; familyName:string; acceptTerms:boolean;  }) => Promise<void>;
}

const validationSchema = yup.object({
    givenName: yup
        .string()
        .required()
        .max(255),
    familyName: yup
        .string()
        .required()
        .max(255),
    email: yup
        .string()
        .required()
        .max(255),
    password: yup
        .string()
        .required()
        .min(8),
    acceptTerms: yup.bool().oneOf([true], 'You must read and accept Terms and Conditions to proceed'),
});

const SignupPage: React.FC<SignupPageProps> = ({ termsURL, handleView, mailSignUp }) => (
    <Card alt="signup page" imageSrc={signupIllustration}>
        <Formik
            initialValues={{
                givenName: "",
                familyName: "",
                email: "",
                password: "",
                acceptTerms:false,
            }}
            validationSchema={validationSchema}
            onSubmit={(data, { setSubmitting, resetForm }) => {
                setSubmitting(true);
                mailSignUp(data);
                setSubmitting(false);
                resetForm();
            }}
        >
            {({ values, isSubmitting }) => (
                <Form>
                    <LeftContainer>
                        <TextContainer>
                            <Title>Join Us</Title>
                        </TextContainer>
                        <InputContainer>
                            <Field
                                name="givenName"
                                label="First Name"
                                type="text"
                                as={Input}
                            />
                            <Field
                                name="familyName"
                                label="Last Name"
                                type="text"
                                as={Input}
                            />
                            <Field
                                name="email"
                                label="Email Address"
                                type="email"
                                as={Input}
                            />
                            <Field
                                name="password"
                                label="Password"
                                type="password"
                                as={Input}
                            />
                            <Field
                                name="acceptTerms"
                                link={termsURL}
                                label="I read and agree with the"
                                textLink="terms and conditions."
                                type="checkbox"
                                as={CheckBox}
                            />
                        </InputContainer>
                        <ButtonContainer>
                            <Button
                                text="Create Account"
                                disabled={isSubmitting}
                                type="submit"
                            />
                        </ButtonContainer>
                        <ExtraContainer>
                            <InlineLink
                                text="Already have an account?"
                                textLink="Sign in!"
                                handleView={() => handleView("login")}
                            />
                        </ExtraContainer>
                    </LeftContainer>
                </Form>
            )}
        </Formik>
    </Card>
);

const LeftContainer = styled.div`
    align-content: center;
    display: grid;
    gap: 1.5em;
    grid-template-rows: repeat(3, min-content);
    height: 100%;
    width: 500px;
`;

const TextContainer = styled.div`
    display: grid;
    gap: 0.2em;
`;

const Title = styled(TextTitle)``;

const Subtitle = styled(TextSubtitle)``;

const InputContainer = styled.div`
    display: grid;
    gap: 1em;
`;

const ButtonContainer = styled.div``;

const ExtraContainer = styled.div`
    display: grid;
    gap: 0.5em;
    grid-template-rows: repeat(2, min-content);
`;
export default SignupPage;
